if (typeof ProductInfo !== 'function') {
	class ProductInfo extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				input: '.quantity-input',
				rules: '.quantity-rules',
				label: '.quantity-label',
				minusButton: 'button[name="minus"]',
				plusButton: 'button[name="plus"]',
				volumePricing: 'volume-pricing',
				pricePerItem: 'price-per-item',
				currentVariant: '.product-variant-id',
				variantSelects: 'variant-radios',
				submitButton: '[type="submit"]',
				quantityForm: '.product-form__quantity',
				loadingOverlay: '.loading-overlay',
			};

			this.classes = {
				hidden: 'hidden',
			};

			// Elements
			this.input = this.querySelector(this.selectors.input);
			this.currentVariant = this.querySelector(this.selectors.currentVariant);
			this.variantSelects = this.querySelector(this.selectors.variantSelects);
			this.submitButton = this.querySelector(this.selectors.submitButton);
			this.quantityForm = this.querySelector(this.selectors.quantityForm);

			// Flags
			this.atts = ['data-cart-quantity', 'data-min', 'data-max', 'step', 'disabled'];

			this.init();
		}

		init() {
			this.setQuantityBoundries();

			if (!this.dataset.originalSection) {
				document.addEventListener(THEME_EVENTS.cartUpdate, (event) => {
					this.fetchQuantityRules();
				});
			}

			document.addEventListener(THEME_EVENTS.variantChange, (event) => {
				const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
				if (event.detail.sectionId !== sectionId) return;
				this.updateQuantityRules(event.detail.sectionId, event.detail.html);
				this.setQuantityBoundries();
			});
		}

		setQuantityBoundries() {
			const data = {
				cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
				min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
				max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
				step: this.input.step ? parseInt(this.input.step) : 1,
			};

			let min = data.min;
			const max = data.max === null ? data.max : Math.max(0, data.max - data.cartQuantity);
			if (max !== null) min = Math.min(min, max);
			if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

			this.input.min = min;
			if (max !== null) {
				this.input.max = max;
			} else {
				this.input.removeAttribute('max');
			}
			this.input.value = min;

			const quantityEvent = new CustomEvent(THEME_EVENTS.quantityUpdate, {
				bubbles: true,
			});

			document.dispatchEvent(quantityEvent);
		}

		fetchQuantityRules() {
			const { classes, selectors } = this;

			if (!this.currentVariant || !this.currentVariant.value) return;

			this.querySelector(selectors.loadingOverlay).classList.remove('hidden');

			fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
				.then((response) => {
					return response.text();
				})
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					this.updateQuantityRules(this.dataset.section, html);
					this.setQuantityBoundries();
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					this.querySelector(selectors.loadingOverlay).classList.add('hidden');
				});
		}

		updateQuantityRules(sectionId, html) {
			const { selectors, atts } = this;

			const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
			if (!quantityFormUpdated) return;

			const elements = [
				selectors.input,
				selectors.rules,
				selectors.label,
				selectors.minusButton,
				selectors.plusButton,
				selectors.volumePricing,
				selectors.pricePerItem,
			];

			const attributeOnlySelectors = [selectors.input, selectors.minusButton, selectors.plusButton];

			for (let element of elements) {
				const current = this.quantityForm.querySelector(element);
				const updated = quantityFormUpdated.querySelector(element);
				if (!current || !updated) continue;
				if (attributeOnlySelectors.includes(element)) {
					const syncedAtts = element === selectors.input ? atts : ['disabled'];
					for (let attribute of syncedAtts) {
						const valueUpdated = updated.getAttribute(attribute);
						if (valueUpdated !== null) {
							current.setAttribute(attribute, valueUpdated);
						} else {
							current.removeAttribute(attribute);
						}
					}
				} else {
					current.innerHTML = updated.innerHTML;
				}
			}
		}
	}

	if (!customElements.get('product-info')) {
		customElements.define('product-info', ProductInfo);
	}
}
